import { render } from "./PrintEachOrderReciept.vue?vue&type=template&id=817093ae"
import script from "./PrintEachOrderReciept.vue?vue&type=script&lang=js"
export * from "./PrintEachOrderReciept.vue?vue&type=script&lang=js"

import "./PrintEachOrderReciept.vue?vue&type=style&index=0&id=817093ae&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__